import { BRAND } from '../lib/brand';
export function Logo({compact=false}:{compact?:boolean}){return <div className="logo-wrap"><div className="logo-mark" aria-hidden="true"><span>M</span><i/></div>{!compact&&<div><strong>{BRAND.name}</strong><small>{BRAND.tagline}</small></div>}</div>}
